module.exports = __webpack_public_path__ + "b27b16ad89e97b7d528880bd1701f47b.fbx";